import React, {Component, ReactNode} from 'react'
import {Box, DialogContent, Typography} from '@mui/material';
import {Close} from '@mui/icons-material'
import {RowFlexContainer} from '../../../../../styledComponents/FlexComponents'
import {NotifyDialogTitle} from '../../../../../components/assocDirector/AssocDirectorCommon'
import {StyledPre} from '../../../../../styledComponents/adminPage/StyledPre'
import {DialogCloseButton} from '../../../../../components/reservations/components/CommonStyle'
import EventEmitterExAdmin from '../../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {
    ApplyAlertButton,
    ApplyDialogActions,
    ApplyPrimaryButton,
    StyledHeader,
    StyledHeadingHr,
    StyledPageFooterArea,
} from './NatAdminApplicationCommon'
import {PageFotterAreaRight} from '../../../../../components/shared/hoc/withAdminPageTemplate'
import {AdminDialog} from '../../../../../components/shared/pageBaseComponents/AdminDialog'
import {AppAdminContext} from '../../../../../app/AppAdminContext'

interface Props {
    open: boolean
    isApproval: boolean
    onCall: () => Promise<void>
    onCancel: () => void
    eventEmitter: EventEmitterExAdmin
}

export default class NatAdminUserRegistrationApplyApprovalDialog extends Component<Props> {
    constructor(props: Readonly<Props>) {
        super(props)
    }

    renderDialogContent(): ReactNode {
        const operationName = this.props.isApproval ? '承認' : '却下'

        return <>
            <Box mb={'16px'}>
                <StyledPre>
                    {'この申請を' + operationName　+ 'します。'}
                    {'\n' + operationName + '操作の取り消しはできません。申請内容に見落としがないか十分にご確認ください。'}
                </StyledPre>
            </Box>
        </>
    }

    render(): ReactNode {
        const {onCall, onCancel, isApproval} = this.props
        const operationName = this.props.isApproval ? '承認' : '却下'

        return (
            <AdminDialog maxWidth={'md'} open={this.props.open}>
                <Box width={'750px'}>
                    <NotifyDialogTitle>
                        <StyledHeader>
                            <RowFlexContainer>
                                <Typography variant="h5" display={'inline'}>
                                    {'申請の' + operationName}
                                </Typography>
                                <DialogCloseButton onClick={onCancel} id={'close'}>
                                    <Close/>
                                </DialogCloseButton>
                            </RowFlexContainer>
                        </StyledHeader>
                        <StyledHeadingHr/>
                    </NotifyDialogTitle>
                    <DialogContent>{this.renderDialogContent()}</DialogContent>
                    <ApplyDialogActions>
                        <StyledPageFooterArea>
                            <PageFotterAreaRight>
                                {isApproval &&
                                    <ApplyPrimaryButton onClick={onCall}>
                                        {'この申請を' + operationName + 'する'}
                                    </ApplyPrimaryButton>
                                }
                                {!isApproval &&
                                    <ApplyAlertButton onClick={onCall}>
                                        {'この申請を' + operationName + 'する'}
                                    </ApplyAlertButton>
                                }
                            </PageFotterAreaRight>
                        </StyledPageFooterArea>
                    </ApplyDialogActions>
                </Box>
            </AdminDialog>
        )
    }
}

NatAdminUserRegistrationApplyApprovalDialog.contextType = AppAdminContext
